'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMostRecentMessageTimestamp = exports.getChatFilterOptions = exports.getFilteredChats = exports.getCurrentConversation = exports.getInitialConversation = exports.getUnseenMessagesCount = exports.getBlockedConversations = exports.getClosedConversations = exports.getOpenConversations = exports.getAllStartedConversations = exports.getInitialOnlineModeConversation = exports.getConversations = exports.getCurrentChannel = exports.getChatFilterSetting = undefined;
exports.getConversationsByStatusType = getConversationsByStatusType;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _reselect = require('reselect');

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _ChatFilterOptions = require('conversations-schema/constants/ChatFilterOptions');

var _ChatFilterOptions2 = _interopRequireDefault(_ChatFilterOptions);

var _strings = require('conversations-core/constants/strings');

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _gateSelectors = require('conversations-core/selectors/gateSelectors');

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getChatFilterSetting = exports.getChatFilterSetting = function getChatFilterSetting(state) {
  return state.adminUi.get('chatFilter');
};
var getCurrentChannel = exports.getCurrentChannel = function getCurrentChannel(state) {
  return state.currentChannel;
};
var getConversations = exports.getConversations = (0, _getIn2.default)(['entities', 'conversations']);

var getInitialOnlineModeConversation = exports.getInitialOnlineModeConversation = (0, _reselect.createSelector)([getConversations], (0, _get2.default)(_strings.INITIAL_ONLINE_MODE_CHANNEL));

function getMostRecentConversationTimestamp(conversation) {
  var timestamp = (0, _PubNubMessageModel.getTimestamp)(conversation.latestMessage);
  if (conversation.latestMessage && timestamp) {
    return timestamp;
  }

  if (conversation.endedAt) {
    return conversation.endedAt;
  }

  if (conversation.lastSeenTimestamp) {
    return conversation.lastSeenTimestamp;
  }

  return conversation.startedAt;
}

function sortByTimestamp(conversations) {
  return conversations.sort(function (a, b) {
    var aTimestamp = getMostRecentConversationTimestamp(a);
    var bTimestamp = getMostRecentConversationTimestamp(b);

    return bTimestamp - aTimestamp;
  });
}

var getInitiatedConversations = function getInitiatedConversations(state) {
  // filter out new conversations
  return sortByTimestamp(getConversations(state).filter(function (conversation) {
    if (!conversation || !conversation.latestMessage) {
      return false;
    }

    var type = (0, _PubNubMessageModel.getType)(conversation.latestMessage);
    var text = (0, _ConversationalMessageModel.getText)(conversation.latestMessage);

    var messageHasNoText = text === null || text === '';
    var newConversation = type === null && messageHasNoText;

    return !newConversation;
  }));
};

var getSortedConversations = (0, _reselect.createSelector)(getConversations, sortByTimestamp);

var conversationStatusSelectorFactory = (0, _underscore.memoize)(function (conversationStatusType) {
  return (0, _reselect.createSelector)([getSortedConversations], function (conversations) {
    return conversations.filter(function (_ref) {
      var status = _ref.status;
      return status === conversationStatusType;
    });
  });
});

var getAllStartedConversations = exports.getAllStartedConversations = (0, _reselect.createSelector)(getConversations, function (conversations) {
  return conversations.filter(_ConversationModel.isStarted);
});

var getOpenConversations = exports.getOpenConversations = conversationStatusSelectorFactory(_ChatFilterOptions2.default.STARTED);
var getClosedConversations = exports.getClosedConversations = conversationStatusSelectorFactory(_ChatFilterOptions2.default.ENDED);
var getBlockedConversations = exports.getBlockedConversations = conversationStatusSelectorFactory(_ChatFilterOptions2.default.BLOCKED);

function getConversationsByStatusType(state, statusType) {
  return conversationStatusSelectorFactory(statusType)(state);
}

var getUnseenMessagesCount = exports.getUnseenMessagesCount = (0, _reselect.createSelector)(getOpenConversations, function (openConversations) {
  return openConversations.reduce(function (totalUnseenCount, _ref2) {
    var unseenCount = _ref2.unseenCount;
    return totalUnseenCount + unseenCount;
  }, 0);
});

var getInitialConversation = exports.getInitialConversation = (0, _reselect.createSelector)([getInitiatedConversations], function (conversations) {
  var url = new _hubspotUrlinator2.default(window.location);
  var currentChannelParam = url.paramValue('currentChannel');
  var conversation = conversations.get(currentChannelParam);
  return conversation || null;
});

var getCurrentConversation = exports.getCurrentConversation = (0, _reselect.createSelector)([getConversations, getCurrentChannel], function (conversations, currentChannel) {
  return conversations.get(currentChannel) || null;
});

var getFilteredChats = exports.getFilteredChats = (0, _reselect.createSelector)([getSortedConversations, getChatFilterSetting], function (conversations, chatFilterSetting) {
  return conversations.filter(function (_ref3) {
    var status = _ref3.status;
    return status === chatFilterSetting;
  });
});

var getChatFilterOptions = exports.getChatFilterOptions = (0, _reselect.createSelector)([getOpenConversations, getClosedConversations, getBlockedConversations, _gateSelectors.isUngatedForBlocking], function (_ref4, _ref5, _ref6, ungatedForBlocking) {
  var openCount = _ref4.size;
  var closedCount = _ref5.size;
  var blockedCount = _ref6.size;

  var filterOptions = [{
    text: _react2.default.createElement(_I18nReact2.default, {
      message: 'buttons.open',
      options: { count: openCount }
    }),
    value: _ChatFilterOptions2.default.STARTED
  }, {
    text: _react2.default.createElement(_I18nReact2.default, {
      message: 'buttons.closed',
      options: { count: closedCount }
    }),
    value: _ChatFilterOptions2.default.ENDED
  }];

  if (ungatedForBlocking) {
    filterOptions.push({
      text: _react2.default.createElement(_I18nReact2.default, {
        message: 'buttons.blocked',
        options: { count: blockedCount }
      }),
      value: _ChatFilterOptions2.default.BLOCKED
    });
  }

  return filterOptions;
});

var getMostRecentMessageTimestamp = exports.getMostRecentMessageTimestamp = (0, _reselect.createSelector)([getOpenConversations], function (openConversations) {
  return openConversations.map(getMostRecentConversationTimestamp).max();
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/conversationSelectors.js
// module id = 30
// module chunks = 0 1